import { t } from 'i18next';
import { ComboBox, DefaultButton, DirectionalHint, IComboBoxOption, Label, TextField, TooltipHost } from '@fluentui/react';
import { Dispatch, SetStateAction } from 'react';
import { FileUpload, IconPapers } from './FileUpload';
import { HourMinuteInput, StatusIcon } from './ImportAct';
import { IAddRows, IComboBoxInput } from './InterfaceFormulario';
import { IActivityRecurring, ItipoConcepto } from '../../system/projects/ProjectsSystem';
import { Callout } from 'office-ui-fabric-react';
import { useActivityEnhancement } from '../../common/custom-hooks/useActivityEnhancement';
import SmartActionButton from '../Common/SmartActionButton';
import { AiGradientIconFilled, AiGradientIconOutline } from '../AiGradientIcon';
import { AiActivityEnhancementSystem } from '../../system/ai/AiActivityEnhancementSystem';
import { TypeMessageEnhancement } from '../../common/custom-hooks/useProjectEnhancement';
import SelectFiles from './SelectFiles';

export interface IActivityRowProps {
  row: IAddRows;
  aiActivityEnhancementSystem: AiActivityEnhancementSystem;
  HandlerNombreAct: (id: string, newValue: string | undefined, option: IActivityRecurring) => void;
  HandlerNombreActNuevo: (id: string, text: string) => void;
  handlerDescripcion: (newValue: string | undefined, rowId: string) => void;
  HandlerContHoras: (id: string, newValue: string | undefined, type: 'hour' | 'minute') => void;
  onselectCountry: (option: IComboBoxOption | undefined, id: string) => void;
  onselectCompany: (option: IComboBoxOption | undefined, id: string) => void;
  onselecTipoConcept: (option: ItipoConcepto | undefined, id: string) => void;
  onselectProject: (option: IComboBoxInput | undefined, id: string, inputText: string | undefined) => void;
  countryFilterChange: (text: string, rowId: string) => void;
  companyFilterChange: (text: string, rowId: string) => void;
  tipoConceptFilterChange: (text: string, rowId: string) => void;
  ProjectFilterChange: (text: string, id: string, listaProyect: IComboBoxOption[]) => void;
  HandlerDeleteRows: (id: string) => void;
  toggleTooltip: () => void;
  onClickCallout: (id: string) => void;
  handlerDuplicateRow: (row: IAddRows) => void;
  setTooltipVisible: Dispatch<SetStateAction<boolean>>;
  updateActivityNameAndDescription: (id: string, newNombreAct: string, newDescripcion: string) => void;
  handleMultipleFiles: (fileList: File[], project: IComboBoxOption, rowId: string) => void;
  handleFileDelete: (index: number, rowId: string) => void;
  listCountries: IComboBoxOption[];
  filterTipoConsept: ItipoConcepto[];
  isMobile: boolean;
}

export default function ActivityRow({
  HandlerContHoras,
  HandlerDeleteRows,
  HandlerNombreAct,
  HandlerNombreActNuevo,
  ProjectFilterChange,
  companyFilterChange,
  countryFilterChange,
  filterTipoConsept,
  handlerDescripcion,
  handlerDuplicateRow,
  isMobile,
  listCountries,
  onClickCallout,
  onselecTipoConcept,
  onselectCompany,
  onselectCountry,
  onselectProject,
  row,
  aiActivityEnhancementSystem,
  tipoConceptFilterChange,
  toggleTooltip,
  setTooltipVisible,
  updateActivityNameAndDescription,
  handleMultipleFiles,
  handleFileDelete,
}: IActivityRowProps) {
  const activityEnhancement = useActivityEnhancement(aiActivityEnhancementSystem);

  const generateAI = () => {
    const activity_name = row.nombreAct;
    const project_name = row.nombrePro.text;
    const activity_description = row.descripcion;
    const company_country = row.paisEmpresa.text;
    const company_name = row.nombreEmp.text;
    const project_code = row.nombrePro.code || '';

    if (!activity_name.trim() || !project_name.trim()) return activityEnhancement.showMessage({ type: TypeMessageEnhancement.WARNING, className: 'warning-message-animate', value: '⚠️ El nombre de la actividad y nombre del proyecto es requerido' });
    activityEnhancement.generateEnhancement({ activity_name, project_name, activity_description, company_country, company_name, project_code }, (result) => {
      updateActivityNameAndDescription(row.id, result.activity_name, result.activity_description);
    });
  };

  const resetAI = () => {
    const original = activityEnhancement.resetToOriginal();
    updateActivityNameAndDescription(row.id, original.activity_name, original.activity_description);
  };

  const countCharactesText = (textItem:string ) => {
    if (!textItem) return '';
    return textItem.length >= 30 ? textItem : '';
  }

  const disabledEnhancementButton = !activityEnhancement.wasGenerated && (activityEnhancement.loading || !row.nombreAct?.trim() || !row.nombrePro.text.trim());

  const proyect = row.filterListProyectos.find(p => Number(p.key) === Number(row.nombrePro.key))
  return (
    <div className="carga-por-formulario-card">
      <div className="carga-por-formulario-grid">
        <div
          style={{
            width: '100%',
            display: 'flex',
          }}
        >
          <ComboBox
            label={t('Pais (*)')}
            placeholder={t('Pais')}
            options={listCountries}
            text={row.paisEmpresa?.text}
            selectedKey={row?.paisEmpresa?.key}
            allowFreeform
            onChange={(_, option) => onselectCountry(option, row.id)}
            onInputValueChange={(text) => countryFilterChange(text || '', row.id)}
            calloutProps={{
              styles: { calloutMain: { width: '300' } },
            }}
            onBlur={() => {
              if (!row.paisEmpresa?.text.trim() && row.paisEmpresa?.key) {
                onselectCountry(undefined, row.id)
              }
            }}
            disabled={!listCountries.length}
          />
        </div>
          <TooltipHost content={countCharactesText(row.nombreEmp?.text)}>
            <ComboBox
              label={t('Empresa (*)')}
              placeholder={t('Empresa')}
              options={row.listaEmpresa}
              text={row.nombreEmp?.text}
              selectedKey={row?.nombreEmp?.key}
              allowFreeform
              onChange={(_, option) => onselectCompany(option, row.id)}
              onInputValueChange={(text) => companyFilterChange(text || '', row.id)}
              calloutProps={{
                styles: { calloutMain: { width: '300px' } },
              }}
              onBlur={() => {
                if (!row.nombreEmp?.text.trim() && row.nombreEmp?.key) {
                  onselectCompany(undefined, row.id)
                }
              }}
              disabled={!row?.paisEmpresa?.key}
            />
          </TooltipHost>
          <TooltipHost content={countCharactesText(row.tipoConcepto?.text)}>
            <ComboBox
              label={t('Concepto (*)')}
              placeholder={t('Indique el concepto')}
              options={filterTipoConsept}
              text={row?.tipoConcepto?.text}
              selectedKey={row?.tipoConcepto?.key}
              allowFreeform
              onChange={(_, option) => onselecTipoConcept(option as ItipoConcepto, row.id)}
              onInputValueChange={(text) => tipoConceptFilterChange(text || '', row.id)}
              calloutProps={{
                styles: { calloutMain: { width: '300px' } },
              }}
              onBlur={() => {
                if (!row.tipoConcepto?.text.trim() && row.tipoConcepto?.key) {
                  onselecTipoConcept(undefined, row.id)
                }
              }}
              disabled={!row?.nombreEmp?.key}
            />
          </TooltipHost>
        <div
          style={{
            width: '100%',
          }}
        >
          <TooltipHost content={countCharactesText(row.nombrePro?.text)}>
            <div
              style={{ display: "flex", alignItems: "center",  gap: 10}}
            >
              <Label
                disabled={!row?.tipoConcepto?.key}
              >
                {t('Nombre del proyecto (*)')}
              </Label>

              {proyect && proyect.pro_inicio && proyect.pro_fin && (
                <TooltipHost content={`El proyecto inicia el ${proyect.pro_inicio.toFormat("dd/LL/yyyy")} y termina el ${proyect.pro_fin.toFormat("dd/LL/yyyy")}`}
                  styles={{root: { display: "flex", alignItems: "center", justifyContent: "center"}}}
                >
                  <IconPapers nameIcon="Info" color='gray'/>
                </TooltipHost>
              )}
            </div>
          </TooltipHost>
          <TooltipHost content={countCharactesText(row.nombrePro?.text)}>
            <ComboBox
              placeholder={t('Indique el proyecto')}
              options={row.filterListProyectos}
              text={row.nombrePro?.text}
              selectedKey={row?.nombrePro?.key}
              allowFreeform
              onChange={(_, option) => onselectProject(option, row.id, '')}
              onInputValueChange={(text) => ProjectFilterChange(text || '', row.id, row.listaProyectos)}
              calloutProps={{
                styles: { calloutMain: { width: '300px' } },
              }}
              onBlur={() => {
                if (!row.nombrePro?.text.trim() && row.nombrePro?.key) {
                  onselectProject(undefined, row.id, '')
                }
              }}
              disabled={!row?.tipoConcepto?.key}
            />
          </TooltipHost>
        </div>
          <TooltipHost content={countCharactesText(row.nombreAct)}>
            <ComboBox
              label={t('Nombre de la actividad (*)')}
              className={activityEnhancement.wasGenerated ? 'input-focus-ai-generate' : ''}
              placeholder={t('Indique el nombre de la actividad')}
              options={row.lisActRecurrente}
              text={row.nombreAct}
              selectedKey={row.nombreAct}
              allowFreeInput
              key={11111}
              onChange={(_, option) => HandlerNombreAct(row.id, option?.text, option as any)}
              onInputValueChange={(text) => HandlerNombreActNuevo(row.id, text)}
              calloutProps={{
                styles: { calloutMain: { width: '300px' } },
              }}
              disabled={!row?.tipoConcepto?.key}
            />
          </TooltipHost>
          <TooltipHost content={countCharactesText(row.descripcion)}>
            <div className="ms-ComboBox-container">
              <TextField
                label={t('Descripción')}
                className={activityEnhancement.wasGenerated ? 'input-focus-ai-generate' : ''}
                placeholder={t('Escriba una Descripción')}
                value={row.descripcion}
                onChange={(e, newValue) => handlerDescripcion(newValue, row.id)}
                multiline
                autoAdjustHeight
                styles={{
                  fieldGroup: { minHeight: 20 },
                  field: { whiteSpace: 'pre-wrap' },
                  root: {
                    maxWidth: 400,
                    maxHeight: 400,
                  }
                }}
                rows={1}
                />
            </div>
          </TooltipHost>
        <div
          style={{
            width: '100%',
            display: 'flex',
          }}
        >
          <div className="ms-ComboBox-container">
            <Label>{t('Horas a cargar (*)')}</Label>
            <HourMinuteInput
              horasCarg={row.horasCarg} // row.horasCarg.split(":")[0]
              onHourChange={HandlerContHoras}
              rowId={row.id}
            />
          </div>
        </div>
        <div className="carga-por-formulario-acciones">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
              paddingTop: '15px',
            }}
          >
            <SmartActionButton
              className="mt-2"
              disabled={disabledEnhancementButton}
              loading={activityEnhancement.loading}
              onClick={activityEnhancement.wasGenerated ? resetAI : generateAI}
              text={activityEnhancement.loading ? t('Mejorando...') : activityEnhancement.wasGenerated ? t('Deshacer') : t('Mejorar ')}
              icon={activityEnhancement.wasGenerated ? <AiGradientIconOutline /> : <AiGradientIconFilled />}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
              paddingTop: '15px',
            }}
          >
            <b style={{ fontWeight: '600' }}>{t('Valida')}</b>
            <TooltipHost content={row.descripcionError}>
              <div onClick={toggleTooltip} onMouseEnter={() => !isMobile && setTooltipVisible(true)} onMouseLeave={() => !isMobile && setTooltipVisible(false)} style={{ cursor: 'pointer' }}>
                <StatusIcon valida={row.valida} />
              </div>
            </TooltipHost>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
              paddingTop: '15px',
            }}
          >
            <b style={{ fontWeight: '600' }}>{t('Adjunto')}</b>
            <SelectFiles
              files={row.files || []}
              onMultipleFiles={(file) => handleMultipleFiles(file, row.nombrePro, row.id)}
              onFileDelete={(index) => handleFileDelete(index, row.id)}
              disabled={!row?.nombrePro?.key}
            />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
              paddingTop: '15px',
            }}
          >
            <b style={{ fontWeight: '600' }}>{t('Eliminar')}</b>
            <IconPapers key={'001'} color={'red'} nameIcon={'Delete'} size={'25px'} thickness={9} onClick={() => HandlerDeleteRows(row.id)} />
          </div>
        </div>
      </div>
      <div>
        <div
          style={{
            width: '20px',
            margin: '0 5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div id={`icon-${row.id}`} onClick={() => onClickCallout(row.id)}>
            <IconPapers key={`icon-${row.id}`} color="dark" nameIcon="MoreVertical" size="20px" thickness={9} />
            {row.options === 1 ? (
              <Callout target={document.getElementById(`icon-${row.id}`)} onDismiss={() => onClickCallout(row.id)} role="alert" calloutWidth={150} directionalHint={DirectionalHint.bottomLeftEdge} isBeakVisible={true} gapSpace={5}>
                <div style={{ padding: '10px' }}>
                  <h4 style={{ margin: 0, marginBottom: '5px' }}>{t('Opciones')}</h4>
                  <DefaultButton
                    text={t('Duplicar fila')}
                    onClick={() => handlerDuplicateRow(row)}
                    style={{
                      border: 'none',
                      fontSize: '14px',
                      fontWeight: '400',
                      cursor: 'pointer',
                    }}
                  />
                </div>
              </Callout>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
